import React from 'react'
import Backdrop from '@mui/material/Backdrop';
import { HashLoader } from "react-spinners";
export default function Loader(props) {  
    
  return (
    <Backdrop
    sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
    open={props.loading}
  >
   <HashLoader color="#FBB04C" />
  </Backdrop>
  )
}
